import { Injectable, signal, Signal } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class DropdownService {

  private readonly openDropdownId = signal<string | null>(null);
  private lastOpenedAt = 0;

  getOpenDropdown(): Signal<string | null> {
    return this.openDropdownId;
  }

  getLastOpenedAt(): number {
    return this.lastOpenedAt;
  }

  toggleDropdown(dropdownId: string) {
    if (this.openDropdownId() === dropdownId) {
      this.openDropdownId.set(null);
    } else {
      this.lastOpenedAt = Date.now();
      this.openDropdownId.set(dropdownId);
    }
  }

  openDropdownDirect(dropdownId: string) {
    this.lastOpenedAt = Date.now();
    this.openDropdownId.set(dropdownId);
  }

  closeDropdown() {
    this.openDropdownId.set(null);
  }
}